import services from "@/shared/http"
import * as types from "./mutations-types"
import { uuid } from "uuidv4";
// import { mockAvailableBalance } from "../components/mock/MockAvaiableBalance";

export const setAllPayments = ({ commit }, data) => {
    commit(types.SET_ALL_PAYMENTS, data)
};


export const setMoneyVisibility = ({ commit }, data) => {
    commit(types.SET_MONEY_VISIBILITY, data)
};


export const setAvailableForRedemption = ({ commit }, data) => {
    commit(types.SET_AVAILABLE_FOR_REDEMPTION, data)
}

export const clearAllPayments = ({ commit }) => {
    commit(types.CLEAR_ALL_PAYMENTS)
};

export const setTypeOfServicesAllowed = ({ commit }, data) => {
    commit(types.SET_TYPE_OF_SERVICES_ALLOWED, data)
}

export const setLastPageOfPagination = ({ commit }, data) => {
    commit(types.SET_LAST_PAGE_OF_PAGINATION, data)
}

export const setPagesAlreadyLoaded = ({ commit }, data) => {
    commit(types.SET_PAGES_ALREADY_LOADED, data)
}

export const setPagesAlreadyLoadedCreditsUnderReview = ({ commit }, data) => {
    commit(types.SET_PAGES_ALREADY_LOADED_CREDITS_UNDER_REVIEW, data)
}

export const setCurrentPageOfPagination = ({ commit }, data) => {
    commit(types.SET_CURRENT_PAGE_OF_PAGINATION, data)
}

export const setIsReloadingComponents = ({ commit }, data) => {
    commit(types.SET_IS_RELOADING_COMPONENTS, data)
}

/* Atualiza a key dos Suspenses na Carteira, forçando a remontagem dos componentes */
export const setCurrentKeyRefreshComponents = ({ commit }, data) => {
    commit(types.SET_CURRENT_KEY_REFRESH_COMPONENTS, data)
}

/**
 * Limpa a lista de paginas já carregadas ( em cache ) de Últimos pagamentos ( LastPayments )
 * Casos em que a lista é limpa: 1º Usuário clicou no botão de refresh
 * 2º Usuário realizou um resgate
 */
export const clearPaginationAlreadyLoaded = ({ commit }) => {
    commit(types.CLEAR_PAGINATION_ALREADY_LOADED)
};

export const fetchCreditsUnderReview = async ({ state, dispatch }, payload) => {
    const { credits_under_review } = state;
    const { pages_already_loaded } = credits_under_review;

    /* Checa se a pág já foi carregada ( Se sim, os dados da pág já estão armazenados ) */
    if ( pages_already_loaded.includes(payload.page) ) return; 

    /* Adiciona a pág atual ao array de pág já carregadas */
    dispatch("setPagesAlreadyLoadedCreditsUnderReview", payload.page)

    const output = await services.my_wallet.getCreditsUnderReview({}, payload)

    dispatch("setCreditsUnderReview", output)

    return output
};

export const getAllRescues = async ({ state, dispatch }, payload) => {
    const { type_of_services_allowed, pages_already_loaded } = state;


    /* Verifica se a página atual já foi carregada ( Não deve carregar duas vezes a mesma página ) */
    if ( pages_already_loaded.includes(payload.page) ) return;

    
    let lastPageOfPagination = 1;
    let dataAllPayments = [];

    dispatch("setPagesAlreadyLoaded", payload.page)

    dispatch("setCurrentPageOfPagination", payload.page)
    
    if ( type_of_services_allowed == "all" ) { 

        try {
            const outputMoney = await services.my_wallet.fetchAllRescuesInMoneyByPeriod({}, payload)

            const { data } = outputMoney;
        
            const { closures: close_commissions, open_commissions } = data;
        
            if ( close_commissions.data.length == 0 && open_commissions?.details?.length == 0 ) {
                dispatch("setTypeOfServicesAllowed", "only_gift_card")
            }


            const { summary, details } = open_commissions

            /* Comissões com periodo em aberto */
            if ( open_commissions && details.length > 0 && payload.page == 1 ) { 

                const allOpenCommissions = details.reverse().map(commission => {
                    return {
                        type: "open",
                        uuid: uuid(),
                        reward_option_id: 2,
                        ...commission,
                        ...summary
                    }
                })

                dataAllPayments = [...allOpenCommissions]
            }

            /* Comissões com periodo fechado */
            if ( close_commissions && Array.isArray(close_commissions.data) ) {

                const { pagination } = close_commissions;

                lastPageOfPagination = pagination.last_page;

                const allPaymentsCloseCommissions = close_commissions.data.map(commission => ({
                    uuid: uuid(),
                    type: "close",
                    reward_option_id: 2,
                    ...commission
                }))

                dataAllPayments = [...dataAllPayments, ...allPaymentsCloseCommissions]
            }
        } catch (error) {
          console.log('Houve um erro ao buscar as comissões sumarizadas', error)  
        }
    }

    const dataGiftRescue = await dispatch("rescue_award/fetchAllRewards", {
        page: payload.page,
        per_page: dataAllPayments.length == 0 ? payload.per_page : ( dataAllPayments.length == 1 ? 2 : ( dataAllPayments.length == 2 ? 2 : 1 ) ) 
    }, { root: true });

    if ( !dataGiftRescue?.data ) return;

     /* Deve deixar apenas os resgates de cartão e voucher ( 7 = Voucher ZZmall ) */
     const leaveOnlyCardAndVoucher = dataGiftRescue.data.filter(
        reward => reward.reward_option_id == 3 || reward.reward_option_id == 6 || reward.reward_option_id == 7 || reward.reward_option_id == 10
    )
    console.log(dataGiftRescue)
    console.log(leaveOnlyCardAndVoucher)

    if ( leaveOnlyCardAndVoucher.length === 0 ) {
        dispatch("setLastPageOfPagination", lastPageOfPagination)

        return dispatch("setAllPayments", {
            page: payload.page,
            data: dataAllPayments
        })
    }

    lastPageOfPagination = lastPageOfPagination > dataGiftRescue.last_page ? lastPageOfPagination : dataGiftRescue.last_page

    dispatch("setLastPageOfPagination", lastPageOfPagination)

    const allPaymentsCardAndVoucher = leaveOnlyCardAndVoucher.map(reward => ({
        uuid: uuid(),
        ...reward
    }))

    dispatch("setAllPayments", {
        page: payload.page,
        data: [...dataAllPayments, ...allPaymentsCardAndVoucher]
    })

    return allPaymentsCardAndVoucher
}

export const setCreditsUnderReview = ({ commit }, data) => {
    commit(types.SET_CREDITS_UNDER_REVIEW, data)
};
